import ProductTypes from './Product.type';

export const setAllProducts = ({ products }: { products: any }) => {
  return {
    type: ProductTypes.SET_ALL_PRODUCTS,
    payload: { products },
  };
};
